import React, { useEffect, useState, useRef } from 'react';
import './Monely.css';

const Monely = React.forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const features = [
    { icon: '💰', title: 'Controle Total', desc: 'Gerencie gastos e receitas facilmente' },
    { icon: '📊', title: 'Gráficos', desc: 'Visualize seus dados em tabelas gráficas' },
    { icon: '🤖', title: 'IA Integrada', desc: 'Avisos sobre gastos excessivos' },
    { icon: '💡', title: 'Dicas Financeiras', desc: 'Sugestões de saúde financeira' },
    { icon: '🔔', title: 'Lembretes', desc: 'Notificações de pagamentos e parcelas' },
    { icon: '📱', title: 'Multi-plataforma', desc: 'Disponível em Mobile e Web' }
  ];

  return (
    <section ref={(el) => { sectionRef.current = el; if (ref) ref.current = el; }} className="monely">
      <div className="monely-background"></div>
      
      <div className="container">
        <div className={`monely-content ${isVisible ? 'visible' : ''}`}>
          <div className="project-header">
            <div className="project-badge monely-badge">App Mobile & Web</div>
            <h2 className="project-title monely-title">Monely</h2>
            <p className="project-subtitle monely-subtitle">
              Seu gerenciador financeiro inteligente. Controle total dos seus gastos com IA.
            </p>
            <a 
              href="https://www.monely.site" 
              target="_blank" 
              rel="noopener noreferrer"
              className="project-link"
            >
              🌐 www.monely.site
            </a>
          </div>

          <div className="project-showcase">
            <div className="features-grid monely-features">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="feature-card monely-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="feature-icon">{feature.icon}</div>
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              ))}
            </div>

            <div className="phone-mockup monely-phone">
              <div className="phone-frame monely-frame">
                <div className="phone-notch"></div>
                <div className="phone-screen monely-screen">
                  <div className="app-preview monely-preview">
                    <div className="preview-icon">💸</div>
                    <h3>Monely</h3>
                    <p>Finanças sob controle</p>
                    <div className="preview-stats">
                      <div className="stat">
                        <div className="stat-value">R$ 2.450</div>
                        <div className="stat-label">Receitas</div>
                      </div>
                      <div className="stat">
                        <div className="stat-value">R$ 1.230</div>
                        <div className="stat-label">Gastos</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="app-screenshots">
            <h3>Screenshots do App</h3>
            <div className="screenshots-grid">
              <div className="screenshot-phone-3d">
                <div className="screenshot-shadow"></div>
                <div className="screenshot-device">
                  <div className="screenshot-notch"></div>
                  <img src="/Monely Print/print Home.jpeg" alt="Monely Home" className="screenshot-img" />
                </div>
              </div>

              <div className="screenshot-phone-3d">
                <div className="screenshot-shadow"></div>
                <div className="screenshot-device">
                  <div className="screenshot-notch"></div>
                  <img src="/Monely Print/Print Add.jpeg" alt="Monely Add Transaction" className="screenshot-img" />
                </div>
              </div>

              <div className="screenshot-phone-3d">
                <div className="screenshot-shadow"></div>
                <div className="screenshot-device">
                  <div className="screenshot-notch"></div>
                  <img src="/Monely Print/Print IA.jpeg" alt="Monely IA" className="screenshot-img" />
                </div>
              </div>

              <div className="screenshot-tablet-3d">
                <div className="screenshot-shadow"></div>
                <div className="screenshot-device-tablet">
                  <img src="/Monely Print/print tablet Add.jpeg" alt="Monely Tablet Add" className="screenshot-img-tablet" />
                </div>
              </div>

              <div className="screenshot-tablet-3d">
                <div className="screenshot-shadow"></div>
                <div className="screenshot-device-tablet">
                  <img src="/Monely Print/Print tablet AI.jpeg" alt="Monely Tablet AI" className="screenshot-img-tablet" />
                </div>
              </div>
            </div>
          </div>

          <div className="monely-highlights">
            <div className="highlight-card">
              <h3>🎯 Relatórios Personalizados</h3>
              <p>Crie relatórios customizados com filtros avançados e análises detalhadas</p>
            </div>
            <div className="highlight-card">
              <h3>🏷️ Categorias Inteligentes</h3>
              <p>Organize seus gastos em categorias personalizadas para melhor controle</p>
            </div>
            <div className="highlight-card">
              <h3>📈 Análise em Tempo Real</h3>
              <p>Acompanhe suas finanças com gráficos e estatísticas atualizadas</p>
            </div>
          </div>

          <div className="tech-stack monely-tech">
            <h3>Tecnologias Utilizadas</h3>
            <div className="tech-tags">
              <span className="tech-tag">React Native</span>
              <span className="tech-tag">React</span>
              <span className="tech-tag">JavaScript</span>
              <span className="tech-tag">IA/ML</span>
              <span className="tech-tag">API REST</span>
              <span className="tech-tag">Charts</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default Monely;
